module.exports = __webpack_public_path__ + "img/logo-ravenol.809c07d6.png";